import PropTypes from 'prop-types'
import React from 'react'
import { pageNames } from './constants/index'
import { LoadingSpinner } from '@paypalcorp/pp-react'

// page imports
const Article = React.lazy(() =>
  import('./pages/article' /* webpackPrefetch: true */),
)
const Home = React.lazy(() =>
  import('./pages/home' /* webpackPrefetch: true */),
)
const Complaints = React.lazy(() =>
  import('./pages/complaints' /* webpackPrefetch: true */),
)
const Search = React.lazy(() =>
  import('./pages/search' /* webpackPrefetch: true */),
)

const Topic = React.lazy(() =>
  import('./pages/topic' /* webpackPrefetch: true */),
)

const AupViolation = React.lazy(() =>
  import('./pages/aupviolation' /* webpackPrefetch: true */),
)

// ContactUs
const ContactUs = React.lazy(() =>
  import('./pages/contact-us' /* webpackPrefetch: true */),
)
// ContactUs
const CallUs = React.lazy(() =>
  import('./pages/call-us' /* webpackPrefetch: true */),
)
// lazy load topic details page
const TopicDetails = React.lazy(() =>
  import('./pages/topic-details' /* webpackPrefetch: true */),
)

// pageName to PageComponent Mapping
const pageComponentMapping = {
  [pageNames.ARTICLE]: Article,
  [pageNames.PERSONAL]: Home,
  [pageNames.BUSINESS]: Home,
  [pageNames.TECHNICAL]: Home,
  [pageNames.COMPLAINTS]: Complaints,
  [pageNames.SEARCH]: Search,
  [pageNames.TOPIC]: Topic,
  [pageNames.AUPVIOLATION]: AupViolation,
  [pageNames.CONTACT_US]: ContactUs,
  [pageNames.CALL_US]: CallUs,
  [pageNames.TOPIC_DETAILS]: TopicDetails,
}

const Page = ({ pageProps }) => {
  const { pageName } = pageProps
  const PageComponent = pageComponentMapping[pageName]

  if (PageComponent) {
    return (
      <div className="container">
        <React.Suspense
          fallback={<LoadingSpinner screenReaderText="loading" size="xl" />}
        >
          <PageComponent />
        </React.Suspense>
      </div>
    )
  }

  // TODO:: Track error FPTI in here
  return <div data-testid="hc-page-not-found" />
}

Page.propTypes = {
  pageProps: PropTypes.object.isRequired,
}
export default Page
